import { getAefiSidebarRoutes } from "constant";
import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { IRoutesProps } from "types";

export const useActiveRoutes = (
  topRoutes: IRoutesProps[],
  bottomRoutes: IRoutesProps[],
  roles: string[]
) => {
  const { pathname } = useLocation();

  const updateRoutes = (routes: IRoutesProps[]) =>
    routes.map((route) => ({
      ...route,
      isActive:
        route.path === pathname ||
        (route.path !== "/" && pathname.includes(route.path)),
      subRoute: route.subRoute?.map((sub) => ({
        ...sub,
        isActive:
          sub.path === pathname ||
          (sub.path !== "/" && pathname.includes(sub.path)),
      })),
    }));

  const activeTopRoutes = useMemo(
    () => updateRoutes(topRoutes),
    [topRoutes, pathname]
  );
  const activeBottomRoutes = useMemo(
    () => updateRoutes(bottomRoutes),
    [bottomRoutes, pathname]
  );

  const activeAefiSidebarRoutes = useMemo(() => {
    return roles.reduce((acc, role) => {
      const roleRoutes = getAefiSidebarRoutes(role);
      acc[role] = updateRoutes(roleRoutes);
      return acc;
    }, {} as Record<string, IRoutesProps[]>);
  }, [roles, pathname]);

  return { activeTopRoutes, activeBottomRoutes, activeAefiSidebarRoutes };
};
